enum LocalStorageKey {
    MODE = '_mode',
    THEME = '_theme',
    SYSTEM_NAME = '_systemName',
    API_VERSION = '_apiVersion',
    MIN_APP_VERSION = '_minAppVersion',
    EMAIL = '_email',
    ACCESS = '_access',
    LAST_ACTIVITY = '_lastActivity',
    TOKEN = '_token',
    EXPIRATION = '_expiration',
}

export default LocalStorageKey;